module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_anchor_arrow_gold-8155a3e516f3361d48d8179bfa99fc9e.svg";